import { formatCurrency } from '../helpers';
import { TABLE_MONEY_COLUMN_KEYS } from '../components/canvas/tableConstants';

/**
 * Get display value for advanced table cells
 * Handles money formatting in preview mode and basic string conversion
 */
export const getAdvancedTableCellDisplayValue = (
  cellValue: any,
  columnKey: string | undefined,
  previewMode: boolean
): string => {
  if (previewMode) {
    if (columnKey && TABLE_MONEY_COLUMN_KEYS.includes(columnKey)) {
      return formatCurrency(cellValue);
    }
    // For non-money columns in preview mode, or if columnKey is undefined
    if (
      cellValue === null ||
      cellValue === undefined ||
      String(cellValue).trim() === ''
    ) {
      return '';
    }
    return String(cellValue);
  } else {
    // Not preview mode - show actual data or blank
    if (
      cellValue === null ||
      cellValue === undefined ||
      String(cellValue).trim() === ''
    ) {
      return '';
    }
    return String(cellValue);
  }
};
